import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";
import { useDeleteJob } from "../apiCalls/jobApiCalls";
import {
  KeyboardArrowRight,
  ExpandMore,
  ArrowBackIos,
  Close
} from "@mui/icons-material";
import moment from "moment";
import { formatted } from "../utils";
import { useGetJobDetails } from "../apiCalls/userApiCalls";

export default function Job() {
  const [workerHoursDetailsVisibility, setWorkerHoursDetailsVisibility] =
    useState({});
    
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const { currentUser } = useSelector((state) => state.userSlice) || null;
  const token = currentUser.token;
  const { jobId } = useParams();

  const { isLoading: isJobDetailsLoading, data: jobDetails } = useGetJobDetails(
    jobId,
    token
  );
  const { mutate: deleteJobMutate, isLoading: isDeleteJobLoading } =
    useDeleteJob();

  function handleWorkerHoursDetails(workerId) {
    setWorkerHoursDetailsVisibility((prevState) => ({
      ...prevState,
      [workerId]: !prevState[workerId],
    }));
  }

  const fallbackImage = "/images/avatar.jpg";

  const handleDelete = (jobId) => {
    setConfirmationPopup(true);
    setDeleteId(jobId);
  };

  const handleCancelDelete = () => {
    setConfirmationPopup(false);
  };

  const handleConfirmDelete = () => {
    const data = {
      jobId: deleteId,
      token: token,
    };
    setConfirmationPopup(false);
    deleteJobMutate(data);
  };

  return (
    <>
      <div className="flex w-full items-center justify-center">
        <div className="mx-6 md:mx-32 lg:mx-44 xl:mx-64 mt-32 w-full lg:w-2/5">
          <div className="fixed lg:left-20 xl:left-32 mt-2 hidden lg:flex lg:items-center lg:justify-center items-center justify-center w-10 h-10 rounded-full bg-white shadow btn-shadow hover:shadow-s, hover:bg-stone-50 transition-colors">
            <button
              onClick={() => window.history.back()}
              className="w-full h-full rounded-full flex items-center justify-center"
            >
              <ArrowBackIos
                style={{ fontSize: 24, paddingLeft: 6, color: "gray" }}
              />
            </button>
          </div>
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-medium pb-4">Job Details</h1>
            <div className="flex gap-2">
              <Link to={`/addHours/${jobId}`}>
                <div className="flex h-full items-center text-center text-white px-4 lg:px-4 py-2 text-xs font-medium tracking-wide hover:scale-105 transition-al bg-[#59c3c2] hover:bg-teal-600 border border-gray-100 rounded-lg">
                  Add Hours
                </div>
              </Link>
              <Link to={`/addBudget/${jobId}`}>
                <div className="flex h-full items-center text-center text-white px-4 lg:px-4 py-2 text-xs font-medium tracking-wide hover:scale-105 transition-al bg-[#59c3c2] hover:bg-teal-600 border border-gray-100 rounded-lg">
                  Add Budget
                </div>
              </Link>
              <Link to={`/editJob/${jobId}`}>
                <div className="flex h-full items-center text-center text-white px-4 lg:px-4 py-2 text-xs font-medium tracking-wide hover:scale-105 transition-al bg-[#59c3c2] hover:bg-teal-600 border border-gray-100 rounded-lg">
                  Edit
                </div>
              </Link>
              <button
                        onClick={() => handleDelete(jobId)}
                        className="flex items-center  text-center text-white px-4 lg:px-4 py-2 text-xs font-medium tracking-wide hover:scale-105 transition-al bg-gradient-to-b from-[#cc3636] to-[#941d1d] hover:bg-stone-50 border border-gray-100 rounded-lg"
                      >
                        {isDeleteJobLoading ? "...Is Deleting" : "Delete"}
                      </button>
            </div>
          </div>
          {isJobDetailsLoading ? (
            <Loader />
          ) : (
            <>
            <div className="flex flex-col gap-4 px-6 border border-gray-100 btn-shadow py-3 rounded-xl">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between ">
                <div className="">
                  <span className="text-xl">
                    <b>{jobDetails.data.data.title}</b>
                  </span>{" "}
                  <br />
                  <span className="">
                    Started on:{" "}
                    {moment(jobDetails.data.data.addedOn).format(
                      "MMM DD, YYYY"
                    )}
                  </span>
                  <br />
                  <span className="">
                    Finished on:{" "}
                    {moment(jobDetails.data.data.endDate).format(
                      "MMM DD, YYYY"
                    )}
                  </span>
                  <br />
                  {jobDetails.data.data.typeTitle && (
                    <>
                      <span className="">
                        Type: {jobDetails.data.data.typeTitle}
                      </span>
                      <br />
                    </>
                  )}
                  <span className="">
                    {jobDetails.data.data.jobType &&
                    jobDetails.data.data.jobType !== "Percentage"
                      ? `Area/Items: ${jobDetails.data.data.amount} ${jobDetails.data.data.jobType}`
                      : `Amount: ${formatted(jobDetails.data.data.amount)}`}
                  </span>
                  <br />
                  <span className="">
                    Sales Person: {jobDetails.data.data.salesId?.name}
                  </span>
                </div>
                <div className="sm:text-right">
                  <span className="">
                    Initial Budget:{" "}
                    {formatted(
                      (jobDetails.data.data.commissionRate *
                        jobDetails.data.data.amount) /
                        100
                    )}
                  </span>
                  <br />

                  {jobDetails.data.data.totalAdditionalBudget && (
                    <>
                      <span className="">
                        Additional Budget:{" "}
                        {formatted(
                          jobDetails.data.data.totalAdditionalBudget | 0
                        )}
                      </span>
                      <br />
                    </>
                  )}

                  <span className="font-semibold">
                    Total Budget:{" "}
                    {formatted(
                      Number(
                        (jobDetails.data.data.commissionRate *
                          jobDetails.data.data.amount) /
                          100
                      ) + Number(jobDetails.data.data.totalAdditionalBudget | 0)
                    )}
                  </span>

                  <br />
                 </div>
               </div>
               {/* Performance Bonus Section - Separate Row */}
               <div className="">
                 {/* Data Columns */}
                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
                   <div className="mb-2 sm:mb-0">
                     <span className="font-medium text-red-500">
                       Labor Used:{" "}
                       {formatted(
                         Number(
                           jobDetails.data.sumPay.normalPay +
                             jobDetails.data.sumPay.overtimePay
                         )
                       )}{" "}
                       | {jobDetails.data.sumPay.totalHours || 0} hours
                     </span>
                   </div>
                   <div>
                     <span className="font-medium text-[#59c3c2]">
                       Performance Bonus:{" "}
                       {formatted(
                         Math.max(
                           0,
                           Number(
                             (jobDetails.data.data.commissionRate *
                               jobDetails.data.data.amount) /
                               100
                           ) +
                             Number(jobDetails.data.data.totalAdditionalBudget | 0) -
                             Number(
                               jobDetails.data.sumPay.normalPay +
                                 jobDetails.data.sumPay.overtimePay
                             )
                         )
                       )}
                     </span>
                   </div>
                 </div>
                 
                 {/* Performance Bar */}
                 <div className="w-full h-5 bg-[#59c3c2] rounded-lg overflow-hidden relative">
                   {(() => {
                     const totalBudget = Number(
                       (jobDetails.data.data.commissionRate *
                         jobDetails.data.data.amount) /
                         100
                     ) + Number(jobDetails.data.data.totalAdditionalBudget | 0);
                     const totalLabor = Number(
                       jobDetails.data.sumPay.normalPay +
                         jobDetails.data.sumPay.overtimePay
                     );
                     const laborPercentage = Math.min((totalLabor / totalBudget) * 100, 100);
                     const bonusPercentage = Math.max(100 - laborPercentage, 0);
                     
                     return (
                       <>
                         <div 
                           className="h-full bg-red-400 transition-all duration-300"
                           style={{ width: `${laborPercentage}%` }}
                         ></div>
                         {bonusPercentage > 0 && (
                           <div 
                             className="absolute right-0 h-full bg-[#59c3c2] transition-all duration-300"
                             style={{ width: `${bonusPercentage}%` }}
                           ></div>
                         )}
                       </>
                     );
                   })()}
                 </div>
                 
                 <div className="mt-2 text-sm font-medium">
                   {(() => {
                     const totalBudget = Number(
                       (jobDetails.data.data.commissionRate *
                         jobDetails.data.data.amount) /
                         100
                     ) + Number(jobDetails.data.data.totalAdditionalBudget | 0);
                     const totalLabor = Number(
                       jobDetails.data.sumPay.normalPay +
                         jobDetails.data.sumPay.overtimePay
                     );
                     const remainingBudget = totalBudget - totalLabor;
                     
                     if (remainingBudget < 0) {
                       return (
                         
                           <span  className="text-red-500"> -${Math.abs(remainingBudget).toFixed(2)} OVER BUDGET</span>
                        
                       );
                     } else {
                       return (
                         <span  className="text-[#59c3c2]"> ${remainingBudget.toFixed(2)} Remaining</span>
                       
                       );
                     }
                   })()}
                 </div>
               </div>
               </div>
               

              <div className="space-y-3 pb-8 pt-10">
                <h1 className="text-2xl font-bold pb-4">Job Hours</h1>

                {jobDetails.data.filteredData.map((worker) => (
                  <div key={worker.id}>
                    <div
                      onClick={() => handleWorkerHoursDetails(worker.id)}
                      className="card flex items-center gap-4 bg-white card-shadow rounded-lg p-4"
                    >
                      <div
                        className="w-16 h-16 border border-gray-200  rounded-full"
                        style={{
                          backgroundImage: `url("${worker.workerImgUrl}"), url("${fallbackImage}")`,
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      <div className="grow">
                        <h2 className="text-lg font-medium tracking-wide">
                          {worker.workerName}
                        </h2>
                      </div>
                      <div className="text-4xl">
                        {workerHoursDetailsVisibility[worker.id] ? (
                          <ExpandMore
                            style={{ fontSize: "44", color: "#d8d8d8" }}
                          />
                        ) : (
                          <KeyboardArrowRight
                            style={{ fontSize: "44", color: "#d8d8d8" }}
                          />
                        )}
                      </div>
                    </div>

                    <div
                      className={`card flex flex-col bg-white card-shadow rounded-lg p-4 overflow-x-auto ${
                        workerHoursDetailsVisibility[worker.id] ? "" : "hidden"
                      }`}
                    >
                      <table className="w-full min-w-max">
                        <thead>
                          <tr>
                            <th className="text-left">Date</th>
                            <th className="text-center">Hours</th>
                            <th className="text-center">Pay</th>
                          </tr>
                        </thead>
                        <tbody>
                          {worker.hours.map((hourlyDetail, index) => (
                            <tr key={index}>
                              <td className="border-t border-gray-200">
                                {moment(hourlyDetail.date).format(
                                  "MMM DD, YYYY"
                                )}
                              </td>
                              <td className="text-center border-t border-gray-200">
                                {hourlyDetail.normalHours +
                                  hourlyDetail.overtimeHours}
                              </td>
                              <td className="text-center border-t border-gray-200 font-medium text-red-500">
                                {formatted(
                                  hourlyDetail.normalPay +
                                    hourlyDetail.overtimePay
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

<div
          className={`${
            confirmationPopup ? "" : "hidden"
          } fixed inset-0 flex items-center justify-center z-50`}
        >
          <div className="bg-white rounded-lg shadow-lg px-8 py-6 relative">
            <div className="flex justify-end">
              <button className=" text-gray-500 hover:text-gray-700 absolute right-2 top-2">
                <Close
                  onClick={() => setConfirmationPopup(false)}
                  style={{ fontSize: "28" }}
                  className="h-5 w-5"
                />
              </button>
            </div>

            <p className="text-lg mb-4 pt-4">
              Are you sure you want to delete?
            </p>
            <div className="flex justify-between">
              <button
                onClick={handleConfirmDelete}
                className="border border-[#cc3636] hover:bg-gradient-to-b hover:text-white from-[#cc3636] to-[#941d1d]  text-gray-800 font-medium py-2 px-4 rounded mr-2"
              >
                Confirm
              </button>
              <button
                onClick={handleCancelDelete}
                className="border border-gray-400 hover:border-gray-300 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
}
